import React from 'react';
import PersianLiteratureDemo from '../components/PersianLiteratureDemo';

const PersianLiteraturePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="container mx-auto px-4">
        <PersianLiteratureDemo />
      </div>
    </div>
  );
};

export default PersianLiteraturePage;

